import getIllumination from './getIllumination.js'


  // Moon phase calculation
 export default function getMoonPhase(date) {
     const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    // Convert date to Julian date
    let a = Math.floor((14 - month) / 12);
    let y = year + 4800 - a;
    let m = month + 12 * a - 3;
    
    let julianDayNoTime = day + Math.floor((153 * m + 2) / 5) + 365 * y + 
                    Math.floor(y / 4) - Math.floor(y / 100) + 
                    Math.floor(y / 400) - 32045;
    let julianDay = julianDayNoTime + (day - Math.floor(day)); // Add time fraction

    // Days since known new moon (January 6, 2000)
    const knownNewMoon = 2451550.29167;
    const daysSinceNew = julianDay - knownNewMoon;
    
    // Moon cycle is approximately 29.53058867 days
    const lunarCycle = 29.53058867;
    const newMoons = daysSinceNew / lunarCycle;
    
    // Get phase (0-1 where 0 and 1 are new moon)
    const phase = newMoons - Math.floor(newMoons);
       
   const getPhaseName = (phase) => {
      if (phase < 0.0625 || phase >= 0.9375) return "New Moon";
      if (phase < 0.1875) return "Waxing Crescent";
      if (phase < 0.3125) return "First Quarter";
      if (phase < 0.4375) return "Waxing Gibbous";
      if (phase < 0.5625) return "Full Moon";
      if (phase < 0.6875) return "Waning Gibbous";
      if (phase < 0.8125) return "Last Quarter";
      return "Waning Crescent";
    };
  
    return { 
      phase, 
      illumination: getIllumination(phase), 
      phaseName: getPhaseName(phase)
      };
  };
  //END
